<template>
  <div class="page-content">
    <el-row  class="product-menu">
      <el-col>
         <el-button type="primary" class="first-btn" @click="addPermission">添加sn</el-button>
         <el-button type="primary" class="first-btn" @click="openHistoryList">历史记录</el-button>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="请输入sn名称" @keyup.enter.native="sel" v-model.trim="snName" clearable>
        <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
        </el-input>
      </el-col>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
         <el-table-column
          prop="deviceSn"
          label="SN"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="设备名"
          align="center"
          >
          <template slot-scope="scope">
            {{JSON.stringify(scope.row.deviceName) === "null"? '---':scope.row.deviceName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="isUse"
          label="使用情况"
          align="center"
          >
          <template slot-scope="scope">
            {{scope.row.isUse === 0? '未使用': '已使用'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作"
          align="center"
          >
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页管理 -->
    <paging :total="total" @changePage="changePage"/>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" @closeAddDialog="closeAddDialog"/>
    <historyDialog v-if="historyFileListFlag" :dialogFlag="historyFileListFlag" @closeHistoryDialog="historyFileListFlag=false"/>
  </div>
</template>

<script>
import addDialog from '@/components/snDialog/addDialog'
import paging from '@/components/paging'
import historyDialog from '@/components/snDialog/historyFile'
import { snList, snDel } from '@/api/productControl'
export default {
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      // checked: false,
      snName: '',
      // 设置表格的样式
      cellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      addDialogVisible: false,
      // viewDialogVisible: false,
      // viewData: null,
      editDialogVisible: false, // 编辑或者查看
      editData: null,
      status: false,
      assignDialogVisible: false, // 分配角色
      userId: '',
      permissionName: '',
      historyFileListFlag: false // 历史文件列表
    }
  },
  components: {
    addDialog,
    historyDialog,
    paging
  },
  created () {
    this.getList()
  },
  methods: {
    sel () {
      this.listQuery.page = 1
      this.getList()
    },
    getList () {
      const params = {
        deviceSn: this.snName,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      snList(params).then(res => {
        const resData = res.data.data
        console.log(resData)
        if (resData.total < 5) {
          this.listLoading = true
        } else {
          this.listLoading = false
        }
        this.total = resData.total
        this.tableData = resData.deviceSnList
        this.tableData.forEach((ele) => {
          if (ele.accessUrl === '' || JSON.stringify(ele.accessUrl) === 'null') ele.accessUrl = '---'
          if (ele.remark === '' || JSON.stringify(ele.remark) === 'null') ele.remark = '---'
        })
      })
    },
    openHistoryList () {
      this.historyFileListFlag = true
    },
    addPermission () {
      this.addDialogVisible = true
    },
    closeAddDialog (val) {
      this.addDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    closeEditDialog (val) {
      this.editDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    closeAssignDialog (val) {
      this.assignDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    handleDelete (row) {
      this.$confirm('正在删除当前sn, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'error'
      }).then(() => {
        const params = {
          snId: row.snId
        }
        snDel(params).then((res) => {
          if (res.data.code === 200 || res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '删除取消'
        })
      })
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
